import React, { useMemo } from 'react';
import { required } from '~/app/helpers/validation';
import Loader from '~/app/common/Loader';
import useForm, { UseFormOptionFields } from '~/app/modules/form/useForm';
import { IssueCompletePayload, IssueDetails } from '~/types';
import classes from './style.module.scss';
import useDidMountEffect from '~/app/hooks/useDidMountEffect';
import Details from './Details';
import Footer from './Footer';
import { useStoreState } from '~/store';

export type FormProps = {
    onClose(): void
    issueDetails: IssueDetails
    onSave?: (id: IssueDetails['id']) => void
}

export type FormComponent = React.FC<FormProps>

const Form: FormComponent = ({ onClose, issueDetails, onSave }) => {
    const isHPCodeRequired = useStoreState(state => state.issue.isHPCodeRequired);

    const formFields = useMemo(() => {
        const fields: UseFormOptionFields = [
            ['comment', {}],
            ['ordinaryHours', { validators: [['required', required]] }],
            ['overTime50', {}],
            ['overTime100', {}],
            ['workType', { validators: [['required', required]] }]
        ];

        if (isHPCodeRequired) {
            fields.push(['hpCode', { validators: [['required', required]] } ]);
        }

        return fields;
    }, [isHPCodeRequired]);

    const { values, defaultValues, removeForm } = useForm<IssueCompletePayload>({
        formName: 'completeIssue',
        fields: formFields,
        defaultValues: {
            comment: '',
            hpCode: 0,
            ordinaryHours: undefined,
            overTime50: undefined,
            overTime100: undefined,
            workType: 0
        }
    });

    useDidMountEffect(() => (() => removeForm()));

    if (!values) {
        return <Loader size="32" />;
    }

    return (
        <>
            <div className={classes['container']}>
                <Details />
            </div>

            <Footer onClose={onClose} issueDetails={issueDetails} defaultFormValues={defaultValues} onSave={onSave} />
        </>
    );
};

export default Form;
